import styled from 'styled-components';

export const StyledPaymentGridForDealCentralScreen = styled.label`
    .ids-input-layout-horizontal > label[for='interstate-checkboxlist-input'] {
        width: 100% !important;
    }
`;
